import React, {
  Children,
  forwardRef,
  InputHTMLAttributes,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import styles from './styles.module.scss';
// import { LayoutContext } from '@/context/LayoutContext';
import ToolbarIcons from '@/icons/toolbar';
// import RenderHelpBox from '@/components/common/RenderHelpBox';
// import { colornames } from 'color-name-list';
import colornames from '@/mock/colors.json';
import RenderHelpBox from '../RenderHelpBox';
// import RenderHelpBox from '../RenderHelpBox';

interface AppInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
  className?: string;
  extraWrapperClass?: string;
  wrapper?: string;
  prefix?: ReactNode;
  prefixClass?: string;
  affix?: ReactNode;
  affixStyle?: string;
  onClickInput?: () => void;
  onChange?: any;
  onKeyDown?: (x: any) => void;
  themeColor?: string;
  affixWrapper?: string;
  showError?: boolean;
  onClickAffix?: () => void;
  error?: string;
  title?: string;
  extraInfoStyle?: string;
  extraInfo?: string;
  disabled?: boolean;
  value?: string | number | undefined;
  showRemoveIcon?: boolean;
  guide?: string;
  inputType?: string;
  child?: ReactNode;
  vertical?: boolean;
  showAffix?: boolean;
}

const AppInput = forwardRef<HTMLInputElement, AppInputProps>((props, ref) => {
  // const { dir } = useContext(LayoutContext);
  const {
    className,
    extraWrapperClass,
    wrapper,
    prefix,
    prefixClass,
    affix,
    affixStyle,
    onClickAffix,
    onClickInput,
    onChange,
    onKeyDown,
    themeColor = 'default',
    affixWrapper = '',
    showError,
    error = '',
    title = '',
    extraInfoStyle = '',
    extraInfo = '',
    disabled = false,
    value = '',
    showRemoveIcon = true,
    guide,
    inputType = 'input',
    vertical = true,
    showAffix = false,
    ...inputProps
  } = props;
  const [focused, setFocused] = useState('');
  console.log('focused==', focused);
  console.log('disabled==', disabled);

  const changeColor = () => {
    const colorNames = colornames;

    function hexToRgb(hex: string | number) {
      // console.log("hex==", hex)
      const v = String(hex)?.replace('#', '');
      const r = parseInt(v.slice(0, 2), 16);
      const g = parseInt(v.slice(2, 4), 16);
      const b = parseInt(v.slice(4, 6), 16);
      return { r, g, b };
    }

    function rgbToHsl(r: number, g: number, b: number) {
      r /= 255;
      g /= 255;
      b /= 255;
      const max = Math.max(r, g, b),
        min = Math.min(r, g, b);
      let h,
        s,
        l = (max + min) / 2;

      if (max === min) {
        h = s = 0;
      } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;
          case g:
            h = (b - r) / d + 2;
            break;
          case b:
            h = (r - g) / d + 4;
            break;
        }
        if (h) {
          h /= 6;
        }
      }

      return {
        h: h && Math.round(h * 360),
        s: Math.round(s * 100),
        l: Math.round(l * 100),
      };
    }
    function dist(a: { r: number; g: number; b: number }, b: { r: number; b: number; g: number }) {
      return (a.r - b.r) ** 2 + (a.g - b.g) ** 2 + (a.b - b.b) ** 2;
    }

    function closestName(hex: string | number) {
      if (hex && colorNames[String(hex).toLowerCase() as keyof typeof colorNames]) {
        // console.log("hhhhh", colorNames[hex.toLowerCase()] )
        return colorNames[String(hex).toLowerCase() as keyof typeof colorNames];
      }

      const target = hexToRgb(hex);
      let best = { name: 'Unknown', d: Infinity };

      for (const [h, name] of Object.entries(colorNames)) {
        const d = dist(target, hexToRgb(h));
        if (d < best.d) best = { name, d };
      }
      // console.log("best==", best?.name)
      return best.name;
    }

    const cp = document.getElementById('cp');
    // const out = document.getElementById("out");
    const hue = document.getElementById('hue');
    const colorn = document.getElementById('colorname');

    if (cp && hue && colorn) {
      const hex = value;
      const name = closestName(value); // e.g. "Red"
      // out.textContent = `${name} (${hex})`;
      const { h, s, l } = rgbToHsl(...(Object.values(hexToRgb(hex)) as [number, number, number])); // Convert to HSL
      // out.textContent = `${name} (${hex}) - Hue: ${h}°, Saturation: ${s}%, Lightness: ${l}%`;

      colorn.textContent = `${name}`;
      hue.textContent = `Hue: ${h}°`;

      // });
    }
    // onChange(e)
  };
  // console.log("value==", value)
  useEffect(() => {
    if (value && props?.type == 'color') {
      changeColor();
    }
  }, [value]);
  return (
    <div
      className={`formItem ${styles.wrapperContainer} relative ${disabled && 'disabled'} ${!vertical && 'horizontalFormItem'} ${extraWrapperClass || ''}`}
      ref={ref}
    >
      {title && (
        <div className={`${styles.title} ${'formTitle'}`}>
          <span>
            {title}
            {extraInfo && <span className={`${extraInfoStyle} starColor`}>{extraInfo}</span>}
          </span>
          {guide && <>{RenderHelpBox(title, guide)} </>}
        </div>
      )}
      <div
        className={`${styles.container} inputPart ${props?.type == 'color' && styles.inputColorContainer}`}
        onClick={props.onClick}
      >
        <div
          className={`${styles.wrapper} withinFocus ${showError && 'inputError'}  ${wrapper || ''} ${props?.type == 'color' && styles.colorInput}`}
        >
          {prefix && <div className={`${styles.prefix} ${prefixClass}`}>{prefix}</div>}
          <input
            {...inputProps}
            // type={props?.type == 'number' ? 'numeric' : 'text'}
            inputMode={props?.type == 'number' ? 'numeric' : 'text'}
            className={`${styles.inputClassName} ${props.className} } ${props?.type == 'color' && 'cursor-pointer'} `}
            onClick={onClickInput}
            onFocus={() => {
              if (!disabled) {
                setFocused(title);
                props.onFocus && props.onFocus;
              }
            }}
            onBlur={() => {
              setFocused('');
              props.onBlur && props.onBlur;
            }}
            onChange={
              !disabled
                ? props?.type == 'color'
                  ? props.onChange
                  : (props.onChange ?? (() => console.log('c')))
                : () => {}
            }
            onKeyDown={props.onKeyDown ?? (() => console.log('k'))}
            value={value}
            disabled={disabled}
            placeholder={props.placeholder}
            id="cp"
          />

          {((showRemoveIcon && value && props?.type != 'color') || affix) && (
            <div className={`${styles.affixContainer} ${affixWrapper}`}>
              {showRemoveIcon && value && (
                <ToolbarIcons.CloseCircleIcon
                  width={'16px'}
                  height={'16px'}
                  fill="#ffffff"
                  onClick={() => {
                    props.onChange({ target: { value: '' } });
                  }}
                  className={`${affix && styles.close}`}
                />
              )}
              {affix && (
                <div className={`${styles.affix} `} onClick={onClickAffix}>
                  {affix}
                </div>
              )}
            </div>
          )}
          {/* {showAffix && affix && (
            <div className={`${styles.affixContainer} ${affixWrapper}`}>
              {affix && <div className={`${styles.affix} `}>{affix}</div>}
            </div>
          )} */}
        </div>
        {props?.type == 'color' && (
          <>
            {/* <p id="out" style={{display:"none"}}></p> */}
            <p id="colorname" className={`${styles.colorname}`}></p>
            <p id="hue" className={`${styles.hueName}`}></p>
          </>
        )}
      </div>
      {props?.child && props?.child}
      {showError == true && <p className={`inputErrorText`}>{error}</p>}
    </div>
  );
});

AppInput.displayName = 'AppInput';
export default AppInput;
